import React from 'react';
import MViewItemCopyFormListItems from './MViewItemCopyFormListItems';
import LoadingButton from '../../../app/common/layout/LoadingButton';

export default function MViewItemCopyFormList(props) {
  const {
    auth,
    scope,
    loading,
    questions,
    answers,
  } = props;
  return (
    <>
      {loading && (
        <tr>
          <td rowSpan={4}>
            <LoadingButton />
          </td>
        </tr>
      )}
      {questions?.[0] &&
        questions.map((question, index) => (
          <MViewItemCopyFormListItems
            auth={auth}
            scope={scope}
            key={index}
            index={index}
            question={question}
            answers={answers}
          />
        ))}
      {!questions?.[0] && (
        <tr>
          <td colSpan={4}>Tidak ada data</td>
        </tr>
      )}
    </>
  );
}
